import { syncTenantConfiguration, TenantConfiguration } from '@msdk/definitions'
import { selector } from 'recoil'

import { $refToken } from '../auth'
import { $apiClient } from '../core'

export const $tenantConfiguration = selector({
  key: 'TenantConfiguration',
  get: async ({ get }) => {
    const client = get($apiClient)
    const token = get($refToken)

    /**
     * this selector could be accessed too early and the user could
     * not be authenticated yes this is why this check is in place
     */
    if (token) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res = await client.read<any>('CMPS/api/Composer/GetTenantConfiguration')
        const tenantConfiguration = res as TenantConfiguration
        syncTenantConfiguration(tenantConfiguration)
        return tenantConfiguration
      } catch (err) {
        console.warn('[tenantConfiguration] error while getting tenant configuration, proceding with defaults!', err)
        return {
          inactivityTimeout: undefined,
          productName: '',
          logging: {
            enabledJournalingEntities: [],
            enabledLoggingEntities: [],
            loggingDataEnabled: false,
            journalingDataEnabled: false,
          },
          trainingEnabled: false,
          lastLoginEnabled: false,
        }
      }
    }
  },
})
